import { makeStyles } from "@material-ui/core";
import { KeyboardTimePicker } from "@material-ui/pickers";
import {
  convertDateTimeWithTimeOnly,
  getTimeFormatted,
} from "components/CustomTimePickerInput";
import { useState } from "react";

const useStyles = makeStyles({
  root: {
    marginTop: "8px",
    paddingBottom: "3px",
    width: "100%",
    "& .MuiOutlinedInput-root": {
      height: "50px",
      "& fieldset": {
        borderColor: "#EAEAEA",
      },
      "&:hover fieldset": {
        borderColor: "#EAEAEA",
      },
    },
  },
});

const ArrivedAtInput = ({ routeLocationData }: any) => {
  const [arriveAt, setArriveAt] = useState<any>(
    routeLocationData.arrivedAt
      ? convertDateTimeWithTimeOnly(routeLocationData.arrivedAt)
      : undefined
  );

  const classes = useStyles();

  return (
    <KeyboardTimePicker
      ampm={false}
      className={classes.root}
      label="Arrived At*"
      inputVariant="outlined"
      variant="inline"
      value={arriveAt}
      onChange={(event: any) => {
        if (event) {
          setArriveAt(new Date(event));
          routeLocationData.arrivedAt = getTimeFormatted(new Date(event));
        } else {
          setArriveAt(null);
          routeLocationData.arrivedAt = null;
        }
      }}
    />
  );
};

export default ArrivedAtInput;
